module.exports = __webpack_public_path__ + "img/icon-member-cost.e8cc43d0.png";